<!--  -->
<template>
  <div class="people-count">
    <div class="date">
      <el-date-picker v-model="statYear" value-format="yyyy" type="year" placeholder="选择年" style="width: 100px"
        @change="handleChange">
      </el-date-picker>
    </div>
    <div id="carbonCountChart" style="height: 100%; width: 98%;"></div>
  </div>
</template>

<script>
import charts from "echarts";
import { Dates } from "$utils";
import API from "../api/index";
export default {
  data() {
    return {
      carbonCountChart: null,
      carbonCountChartOption: {},
      xData: [],
      yData: [[], [], []],
      statYear: Dates.format(new Date(), "yyyy"),
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;
    self.carbonCountChart = charts.init(
      document.getElementById("carbonCountChart")
    );
    self.init();
  },

  methods: {
    init() {
      let self = this;
      self.queryData().then((res) => {
        self.initTrafficChartOption(res);
      });
    },
    handleChange(data) {
      this.statYear = data;
      this.init();
    },
    // queryData() {
    //   this.xData = [];
    //   this.yData = [[]];
    //   return new Promise((resolve, reject) => {
    //     this.$fetch(API.carbonByMonth, { statYear: this.statYear }).then(
    //       (res) => {
    //         if (res.success) {
    //           let obj = res.returnObj.list[0];
    //           for (let key in obj) {
    //             let inde = key.indexOf("month");
    //             if (inde > -1) {
    //               let i = inde + 5;
    //               let el = key.substring(i);
    //               this.xData.push(el);
    //               this.yData[0].push(obj[key]);
    //             }
    //           }
    //           // res.returnObj.list.forEach((el) => {
    //           //   this.xData.push(el.time);
    //           //   this.yData[0].push(el.total);
    //           //   // this.yData[1].push(el.personnelOutCount);
    //           // });
    //           resolve({ xData: this.xData, yData: this.yData });
    //         } else {
    //           this.$message.error(res.msgContent);
    //         }
    //       }
    //     );
    //   });
    // },
    queryData() {
      this.xData = [];
      this.yData = [[], [], []];
      return new Promise((resolve, reject) => {
        this.$fetch('/bms/carbon/monthly/carbon/emission/trends.json', { statYear: this.statYear }).then(
          (res) => {
            if (res.success) {
              let obj = res.returnObj;
              for (let i = 0; i < obj.length; i++) {
                this.xData.push(obj[i].keyX);
                this.yData[0].push(Number(obj[i].electricity).toFixed(2));
                this.yData[1].push(Number(obj[i].gas).toFixed(2));
                this.yData[2].push(Number(obj[i].petroleum).toFixed(2));
              }
              resolve({ xData: this.xData, yData: this.yData });
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      });
    },
    // initTrafficChartOption(carbondata) {
    //   //   let xData = ["1", "2", "3", "4", "5", "6", "7", "8", "17"];
    //   let lenData = ["排放量"];
    //   let data1 = [[220, 182, 191, 210, 230, 270, 270, 201, 154]];
    //   let color = ["#00ADEF"];

    //   const hexToRgba = (hex, opacity) => {
    //     let rgbaColor = "";
    //     let reg = /^#[\da-f]{6}$/i;
    //     if (reg.test(hex)) {
    //       rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
    //         "0x" + hex.slice(3, 5)
    //       )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
    //     }
    //     return rgbaColor;
    //   };
    //   //数据处理
    //   let datas = [];
    //   lenData.map((item, index) => {
    //     datas.push({
    //       name: item,
    //       type: "line",
    //       smooth: false,
    //       symbol: "none",
    //       symbolSize: 4,
    //       zlevel: 3,
    //       itemStyle: {
    //         color: hexToRgba(color[index], 0.4),
    //         borderColor: hexToRgba(color[index], 0.4),
    //         borderWidth: 5,
    //       },
    //       areaStyle: {
    //         normal: {
    //           color: new charts.graphic.LinearGradient(
    //             0,
    //             0,
    //             0,
    //             1,
    //             [
    //               {
    //                 offset: 0,
    //                 color: hexToRgba(color[index], 0.4),
    //               },
    //               {
    //                 offset: 1,
    //                 color: hexToRgba(color[index], 0.1),
    //               },
    //             ],
    //             false
    //           ),
    //           shadowColor: hexToRgba(color[index], 0.1),
    //           shadowBlur: 10,
    //         },
    //       },
    //       data: this.yData[index],
    //     });
    //   });
    //   this.carbonCountChartOption = {
    //     grid: {
    //       bottom: 15,
    //       containLabel: true,
    //       left: 25,
    //       right: 10,
    //     },
    //     tooltip: {
    //       trigger: "axis",
    //       axisPointer: {
    //         type: "shadow",
    //       },
    //     },
    //     legend: {
    //       top: 10,
    //       right: 10,
    //       data: lenData,
    //       textStyle: {
    //         // color: "#91abd9",
    //         color: "#ffffff",
    //       },
    //       itemGap: 10,
    //       itemWidth: 20,
    //       itemHeight: 12,
    //     },
    //     yAxis: [
    //       {
    //         type: "value",
    //         name: "单位：tCO2e",
    //         axisLabel: {
    //           show: true,
    //           width: "100",
    //           height: 12,
    //           fontSize: 14,
    //           fontFamily: "Source Han Sans SC",
    //           fontWeight: 400,
    //           // color: "#92A8D9",
    //           color: "#ffffff",
    //         },
    //         nameTextStyle: {
    //           // color: "#92A8D9",
    //           color: "#ffffff",
    //           align: "left",
    //           padding: [0, 0, 0, -20],
    //           lineHeight: 40,
    //           height: 12,
    //           fontSize: 12,
    //           fontFamily: "Source Han Sans SC",
    //           fontWeight: 400,
    //         },
    //         axisLine: {
    //           show: false,
    //           lineStyle: {
    //             color: "rgb(10, 59, 119)",
    //           },
    //         },
    //         splitLine: {
    //           show: true,
    //           lineStyle: {
    //             color: "#1E2537",
    //             type: "solid",
    //           },
    //         },
    //         axisTick: {
    //           show: false,
    //         },
    //       },
    //     ],
    //     xAxis: [
    //       {
    //         data: this.xData,
    //         type: "category",
    //         axisTick: {
    //           show: false,
    //         },
    //         axisLabel: {
    //           // color: "#92A8D9",
    //           color: "#ffffff",
    //           height: 13,
    //           fontSize: 14,
    //           fontFamily: "Source Han Sans SC",
    //           fontWeight: 400,
    //         },
    //         axisLine: {
    //           show: true,
    //           lineStyle: {
    //             color: "#1E2537",
    //           },
    //         },
    //       },
    //     ],
    //     series: datas,
    //   };
    //   //   this.charts.carbonQsChart.setOption(this.options.carbonQsChartOption)
    //   this.carbonCountChart.setOption(this.carbonCountChartOption);
    // },
    initTrafficChartOption() {
      this.carbonCountChartOption = {
        color: ['#5470C0', '#91CC75', '#FAC858'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: "rect",
          itemHeight: 12,
          itemWidth: 25,
          right: 20,
          top: 25,
          textStyle: {
            color: "#ffffff",
          },
        },
        grid: {
          left: '1%',
          right: '8%',
          bottom: '10%',
          top: '23%',
          containLabel: true
        },
        xAxis: {
          name: '月',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#ffffff'
            }
          },
          axisLabel: {
            color: "#ffffff",
            height: 13,
            fontSize: 14,
            fontFamily: "Source Han Sans SC",
            fontWeight: 400,
          },
          // axisLabel: {
          //   interval: 0,//横轴信息全部显示
          //   rotate: -50,// -20度角倾斜显示
          // },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：tCO2e",
          axisLabel: {
            show: true,
            width: "100",
            height: 12,
            fontSize: 14,
            fontFamily: "Source Han Sans SC",
            fontWeight: 400,
            color: "#ffffff",
          },
          nameTextStyle: {
            color: "#ffffff",
            align: "left",
            padding: [0, 0, 0, -20],
            lineHeight: 40,
            height: 12,
            fontSize: 12,
            fontFamily: "Source Han Sans SC",
            fontWeight: 400,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgb(10, 59, 119)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.15)", // 分割线颜色
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: '电',
            type: 'line',
            smooth: true,
            data: this.yData[0]
          },
          {
            name: '气',
            type: 'line',
            smooth: true,
            data: this.yData[1]
          },
          {
            name: '油',
            type: 'line',
            smooth: true,
            data: this.yData[2]
          }
        ]
      };
      this.carbonCountChart.setOption(this.carbonCountChartOption);
    },
  },
};
</script>
<style lang='scss' scoped>
.people-count {
  height: 100%;
  position: relative;
}

.date {
  position: absolute;
  right: 18px;
  top: -50px;
}
</style>
